import enMessages from "../locales/en_US.json";

const enLang = {
	messages: {
		...enMessages,
	},
	locale: "en",
};
export default enLang;
